import { gql } from '@apollo/client'

import { INGREDIENT_KEYWORD_NODE_FRAGMENT } from '../../../common/graphql/fragments'

const UPDATE_TRANSFERED_KEYWORDS_MUTATION = gql`
  mutation updateTransferedKeywords(
    $id: ID!
    $idToTransferTo: ID!
    $data: [IngredientKeywordInput!]!
  ) {
    updateTransferedKeywords(
      id: $id
      idToTransferTo: $idToTransferTo
      data: $data
    ) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      uncategorized {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }

      synonyms {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }

      varieties {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }

      discarded {
        ...IngredientKeywordNode
        children {
          ...IngredientKeywordNode
          children {
            ...IngredientKeywordNode
            children {
              ...IngredientKeywordNode
            }
          }
        }
      }
    }
  }
  ${INGREDIENT_KEYWORD_NODE_FRAGMENT}
`

export default UPDATE_TRANSFERED_KEYWORDS_MUTATION
